import { Incident } from '../../maritime-menu-options/incidents-panel/incident.model';
import { Port } from '../../maritime-menu-options/world-ports-panel/world-ports.model';
import {
  ExpandedCity,
  ExpandedCountry,
  ExtendedMaritimeArea,
} from '../risk-intelligence/risk_intelligence.model';
import { Route } from '../routes/routes.model';

interface HistoryItem {
  type:
    | 'history'
    | 'port'
    | 'route'
    | 'city'
    | 'country'
    | 'portList'
    | 'incidentList'
    | 'map'
    | 'search'
    | 'RIareaslist'
    | 'RiArea'
    | 'myFleet'
    | 'fleets'
    | 'drawings'
    | 'incident'
    | 'routeList'
    | 'alert';
}

interface SkeletonPort {
  NAME: string;
  ri: {
    id: number;
  };
}

type PortHistoryItem = HistoryItem & {
  type: 'port';
  properties: Port | SkeletonPort;
};

type CityHistoryItem = HistoryItem & {
  type: 'city';
  properties: ExpandedCity;
};

type CountryHistoryItem = HistoryItem & {
  type: 'country';
  properties: ExpandedCountry;
};

type RiAreaHistoryItem = HistoryItem & {
  type: 'RiArea';
  properties: ExtendedMaritimeArea;
};

type RouteHistoryItem = HistoryItem & {
  type: 'route';
  properties: Route;
};

type IncidentHistoryItem = HistoryItem & {
  type: 'incident';
  properties: Incident;
};

export type IndividualHistoryItem =
  | PortHistoryItem
  | CityHistoryItem
  | CountryHistoryItem
  | RiAreaHistoryItem
  | RouteHistoryItem
  | IncidentHistoryItem;

interface NoPropsHistoryItem extends HistoryItem {
  type:
    | 'history'
    | 'portList'
    | 'map'
    | 'search'
    | 'RIareaslist'
    | 'myFleet'
    | 'fleets'
    | 'drawings'
    | 'routeList'
    | 'incidentList'
    | 'alert';
}

export type GenericHistoryItem = IndividualHistoryItem | NoPropsHistoryItem;

export const isNoPropsItem = (
  item: GenericHistoryItem
): item is NoPropsHistoryItem => {
  if (
    item.type === 'map' ||
    item.type === 'portList' ||
    item.type === 'history' ||
    item.type === 'incidentList' ||
    item.type === 'search' ||
    item.type === 'RIareaslist' ||
    item.type === 'myFleet' ||
    item.type === 'fleets' ||
    item.type === 'drawings' ||
    item.type === 'routeList'
  ) {
    return true;
  }
  return false;
};
